export default __webpack_public_path__ + "static/comms-dc28e1e52706ba78051d5a86627eef62.png";